import { useTranslation } from 'react-i18next'

import { CheckCircleIcon, WarningIcon } from '@phosphor-icons/react'

import { FormatNumber, Text } from '@reveni-io/reveni-ui'

import * as Styles from './styles'

const FooterMessage = ({ percentage, missingCount }) => {
  const { t } = useTranslation()

  return (
    <>
      {Number(percentage) < 100 ? (
        <Styles.AlertContainer>
          <Styles.ActionRequiredContainer>
            <Styles.AlertMessage>
              <WarningIcon />
              <Text type="bodySBold">{t('Acción requerida')}</Text>
            </Styles.AlertMessage>
            <Styles.ActionRequiredInfo>
              <Text type="bodySBold">
                <FormatNumber style="percent">{100 - percentage}</FormatNumber>
              </Text>
              <Text type="bodySRegular">
                | {missingCount} {t(missingCount > 1 ? 'productos' : 'producto')}
              </Text>
            </Styles.ActionRequiredInfo>
          </Styles.ActionRequiredContainer>
        </Styles.AlertContainer>
      ) : (
        <Styles.SuccessContainer type="warning">
          <Styles.ActionRequiredContainer>
            <Styles.AlertMessage>
              <CheckCircleIcon />
              <Text type="bodyMBold">{t('Todo en orden')}</Text>
            </Styles.AlertMessage>
          </Styles.ActionRequiredContainer>
        </Styles.SuccessContainer>
      )}
    </>
  )
}

export default FooterMessage
